export { default } from "./ZoomableImage";
